export const goToCart = (locale: string): void => {
  window.location.href = `/${locale}/cart`;
};

export const goToCategories = (locale: string, category: string): void => {
  window.location.href = `/${locale}/categories/${category}`;
};

export const goToDrafts = (locale: string): void => {
  window.location.href = `/${locale}/dashboard/drafts`;
};

export const goToCustomization = (locale: string, id: number): void => {
  window.location.href = `/${locale}/customizations/${id}/edit`;
};

export const goToOrder = (orderId: string): void => {
  window.location.href = `orders/${orderId}`;
};
